import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import moment from "moment";
import { get } from "lodash";

import { typeStatisticBy } from "../constant";
import { formatCurrency } from "utils";
const renderZeroAsDefault = (value = 0) => value;
const renderMoney = (value = 0) => formatCurrency(value);

export const dataIndex = {
  totalTransaction: "total_transaction",
  totalRM: "total_collection_RM",
};

const useColumns = ({ statisticBy } = {}) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      [
        statisticBy === typeStatisticBy.daily && {
          title: t("week"),
          key: "week",
          dataIndex: "date",
          fixed: "left",
          width: 55,
          className: "background-gray",
          render: (date) => moment(date).format("w"),
        },
        statisticBy === typeStatisticBy.daily && {
          title: t("day"),
          key: "day",
          dataIndex: "date",
          fixed: "left",
          width: 60,
          className: "background-gray",
          render: (date) => moment(date).format("ddd"),
        },
        {
          title: t("date"),
          dataIndex: "date",
          key: "date",
          fixed: "left",
          width: 130,
          className: "background-gray",
          render: (date) => moment(date).format(statisticBy === typeStatisticBy.monthly ? "MMM/YYYY" : "LL"),
        },
        {
          title: t("statisticTb.totalTransaction"),
          dataIndex: dataIndex.totalTransaction,
          key: "total_transaction",
          render: renderZeroAsDefault,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.totalRM"),
          dataIndex: dataIndex.totalRM,
          key: "total_collection_RM",
          render: renderMoney,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.totalCompleted"),
          dataIndex: "total_transaction_completed",
          key: "total_transaction_completed",
          render: renderZeroAsDefault,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.RMCompleted"),
          dataIndex: "total_collection_RM_completed",
          key: "total_collection_RM_completed",
          render: renderMoney,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.toBank"),
          dataIndex: "total_transaction_to_bank",
          key: "total_transaction_to_bank",
          render: renderZeroAsDefault,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.RMToBank"),
          dataIndex: "total_collection_RM_to_bank",
          key: "total_collection_RM_to_bank",
          render: renderMoney,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.toCharity"),
          dataIndex: "total_transaction_to_charity",
          key: "total_transaction_to_charity",
          render: renderZeroAsDefault,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.RMToCharity"),
          dataIndex: "total_collection_RM_to_charity",
          key: "total_collection_RM_to_charity",
          render: renderMoney,
          showingInFooter: true,
        },
        {
          title: t("statisticTb.average"),
          key: "average",
          render: (rowData) => {
            const average = get(rowData, dataIndex.totalRM, 0) / get(rowData, dataIndex.totalTransaction, 1);

            return renderMoney(+Number.parseFloat(average).toFixed(2));
          },
        },
        {
          title: t("statisticTb.RMFee"),
          key: "total_transaction_fee",
          dataIndex: "total_transaction_fee",
          render: renderMoney,
          showingInFooter: true,
        },
      ].filter(Boolean),
    [t, statisticBy]
  );
};

export default useColumns;
